module.exports = __webpack_public_path__ + "static/media/feishu_iuxlabs-0001.9be8a3e4.png";